<template>
  <div class="wg-col wg-xs-12" style="padding: 2%">
    <div style="font-size: 24px" class="com-anm22-app-text-m">
      {{ ticketType.name }}
    </div>
    <div class="vertical-height-div" style="height: 20px"></div>

    <div class="events-list">
      <div class="wg-row event-row header">
        <div class="status">{{ $anm22.strLang(lang, "Status", "Stato") }}</div>
        <div class="name">{{ $anm22.strLang(lang, "Name", "Nome") }}</div>
        <div class="date">{{ $anm22.strLang(lang, "Date", "Date") }}</div>
        <div class="one-event">
          {{ $anm22.strLang(lang, "One event", "One event") }}
        </div>
      </div>
      <div
        class="wg-row event-row"
        v-for="(event, index) in events"
        :key="index"
      >
        <div class="status">
          <div
            v-if="isEnabledEvent(event)"
            class="status-btn enabled"
            @click="removeEvent(event)"
          >
            ✓
          </div>
          <div v-else class="status-btn disabled" @click="addEvent(event)">
            X
          </div>
        </div>
        <div class="name">{{ getEventName(event) }}</div>
        <div class="date">
          {{ $moment.unix(event.startTimestamp).format("YYYY-MM-DD") }} -
          {{ $moment.unix(event.endTimestamp).format("YYYY-MM-DD") }}
        </div>
        <div class="one-event">
          <select
            class="input-elem print-elem com-anm22-app-select"
            @change="updateOneEventTicketType(event, $event.target.value)"
            :disabled="!ticketType.isPermanent || !isEnabledEvent(event)"
          >
            <option :selected="!getOneEventTicketType(event)">
              {{ $anm22.strLang(lang, "Select", "Seleziona") }}
            </option>
            <option
              v-for="(ticketTypeItem, index) in ticketTypes.filter(
                (t) => !t.deleted && !t.isPermanent && t.isVehicle == ticketType.isVehicle
              )"
              :key="index"
              :value="ticketTypeItem.idWorldCardType"
              :selected="
                getOneEventTicketType(event) == ticketTypeItem.idWorldCardType
              "
            >
              {{ ticketTypeItem.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="empty-list-msg" v-if="!events || events.length == 0">
        {{ $anm22.strLang(lang, "No events.", "Nessun evento.") }}
      </div>
    </div>

    <div class="vertical-height-div" style="height: 20px"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WGPageControls from "../../../../world/spa/components/WGPageControls.vue";
import events from "../store/modules/events";

export default {
  components: {
    WGPageControls,
  },
  data() {
    return {
      ticketType: null,
      ticketTypeEvents: [],
      events: [],
      ticketTypes: [],
      mode: "edit",
      openModal: false,
      currentTicket: {},
      pageResultsNum: 50,
      pageOffset: 0,
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
    }),
    ticketTypeId() {
      return this.$route.params.id;
    },
  },
  methods: {
    loadData() {
      this.$http
        .get("tickets/type-events/?id=" + this.$route.params.id)
        .then((response) => {
          this.ticketType = response.data.cardType;
          this.ticketTypeEvents = response.data.cardTypeEvents;
          this.events = response.data.events;
          this.ticketTypes = response.data.cardTypes;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateTicketTypeEventAssoc(event, status) {
      this.$http
        .post(
          "tickets/type-events/?id=" + this.$route.params.id,
          {
            ticketType: this.ticketType,
            event: event.idWorldEvent,
            status,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: this.$anm22.strLang(
              this.lang,
              "Ticket type successfully saved",
              "Tipologia biglietto aggiornata"
            ),
            type: "confirm",
          });
          this.loadData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addEvent(event) {
      this.updateTicketTypeEventAssoc(event, true);
    },
    removeEvent(event) {
      this.updateTicketTypeEventAssoc(event, false);
    },
    isEnabledEvent(event) {
      if (this.ticketTypeEvents) {
        var assoc;
        for (var i = 0; i < this.ticketTypeEvents.length; i++) {
          assoc = this.ticketTypeEvents[i];
          if (assoc.event == event.idWorldEvent) {
            return true;
          }
        };
      }
      return false;
    },
    getOneEventTicketType(event) {
      if (this.ticketTypeEvents) {
        var assoc;
        for (var i = 0; i < this.ticketTypeEvents.length; i++) {
          assoc = this.ticketTypeEvents[i];
          if (assoc.event == event.idWorldEvent) {
            return assoc.oneEventCardType;
          }
        }
      }
      return null;
    },
    updateOneEventTicketType(event, oneEventTicketType) {
      this.$http
        .post(
          "tickets/type-events/?id=" + this.$route.params.id,
          {
            ticketType: this.ticketType,
            event: event.idWorldEvent,
            oneEventTicketType,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          this.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: this.$anm22.strLang(
              this.lang,
              "Ticket type successfully saved",
              "Tipologia biglietto aggiornata"
            ),
            type: "confirm",
          });
          this.loadData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getEventName(event) {
      if (event.jsonData && typeof event.jsonData === 'object' && !Array.isArray(event.jsonData) && event.jsonData.motorsportCategory) {
        return event.jsonData.motorsportCategory.toUpperCase() + " " + event.name;
      } else {
        return event.name;
      }
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
.events-list {
  overflow-x: auto;

  .event-row {
    border-radius: 8px;
    min-height: 49px;
    padding: 5px;
    flex-wrap: nowrap;
    max-width: 1700px;

    &:hover {
      background-color: #f9f9f9;
    }
    div {
      display: inline-block;
      vertical-align: top;
      white-space: normal;
      padding: 11px;

      &.status {
        flex: 1;
        width: 80px;
        min-width: 80px;
        max-width: 80px;

        .status-btn {
          border-radius: 4px;
          width: 18px;
          height: 18px;
          padding: 1px 0 0 0;
          text-align: center;
          font-weight: 500;
          cursor: pointer;

          &.enabled {
            color: #fff;
            background-color: #00c853;
          }
          &.disabled {
            color: #fff;
            background-color: #d50000;
          }
        }
      }
      &.name {
        flex: 2;
        width: 20%;
        min-width: 120px;
      }
      &.date {
        flex: 1;
        width: 20%;
        min-width: 120px;
      }
      &.one-event {
        flex: 1;
        width: 20%;
        min-width: 120px;
        padding: 0 11px;
      }
    }

    &.header {
      div {
        font-weight: 600;

        &.one-event {
          padding: 11px;
        }
      }

      &:hover {
        background: none !important;
      }
    }
  }

  .empty-list-msg {
    padding: 16px;
  }
}

.tickets-list-menu {
  align-items: center;
  max-width: 1700px;
}
</style>
